interface modType {
    key: string,
    name: string,
    dur: boolean
}

 const modsTypes: modType[] = [
    {key: 'constant', name: 'dauernd', dur: false},
    {key: 'rolls', name: 'W�rfe', dur: true},
    {key: 'rounds', name: 'Runden', dur: true},
    {key: 'minutes', name: 'Minuten', dur: true},
    {key: 'hours', name: 'Stunden', dur: true},
]

export default modsTypes